import React from "react";
import "./ShopByConcern.css";
import acne from "../../Images/acne.webp";
import Hair from "../../Images/hair care.webp";
import dullskin from "../../Images/Dull Skin.webp";
import tan from "../../Images/Tanning (1).webp";
import oily from "../../Images/Oily skin.webp";
import dry from "../../Images/Dry skin.webp";
import pimple from "../../Images/pimple1.jpg";
import spot from "../../Images/spot.jpg";
import { Link } from "react-router-dom";
import leaf4 from "../../Images/leaf1.png";

const ShopByConcern = () => {
  return (
    <div className="relative overflow-hidden">
      {/* Decorative background leaf image */}
      <img
        className="w-[100px] bg-img lg:w-[300px] absolute top-[50%] right-0 lg:right-[-40px] fa-rotate-270"
        alt="Natural leaf decorative background"
        src={leaf4}
        loading="lazy"
      />

      {/* ✅ Semantic landmark for better SEO & accessibility */}
      <section
        aria-labelledby="shop-by-concern-heading"
        className={`flex flex-col px-[10px] items-center sm:px-[20px] lg:px-[0px] lg:w-[90%] mx-auto mb-10 ${
          window.innerWidth >= 1920 ? "2xl:w-[65%]" : "2xl:w-[80%]"
        }`}
      >
        {/* ✅ SEO-friendly heading with keyword context */}
        <h2
          id="shop-by-concern-heading"
          className="text-center text-xl text-accent font-bold mt-[50px] sm:text-2xl"
        >
          Shop by Skin & Hair Concerns
        </h2>
        <div className="w-[100px] mx-auto h-1 bg-accent my-6 mb-10"></div>

        {/* ✅ Grid of categories */}
        <div className="grid grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 featured-collections">
          <Link
            to="/product-category/acne"
            className="flex flex-col items-center justify-center mb-10"
            title="Shop skincare products for acne treatment"
          >
            <img
              src={acne}
              alt="Acne skincare solutions"
              loading="lazy"
            />
            <p className="font-bold text-xl mt-4">Acne</p>
          </Link>

          <Link
            to="/product-category/haircare"
            className="flex flex-col items-center justify-center mb-10"
            title="Explore natural haircare products"
          >
            <img
              src={Hair}
              alt="Hair care products for healthy hair"
              loading="lazy"
            />
            <p className="font-bold text-xl mt-4">Hair Care</p>
          </Link>

          <Link
            to="/product-category/dull skin"
            className="flex flex-col items-center justify-center mb-10"
            title="Brightening products for dull skin"
          >
            <img
              src={dullskin}
              alt="Brightening solutions for dull skin"
              loading="lazy"
            />
            <p className="font-bold text-xl mt-4">Dull Skin</p>
          </Link>

          <Link
            to="/product-category/tanning"
            className="flex flex-col items-center justify-center mb-10"
            title="Anti-tanning skincare products"
          >
            <img
              src={tan}
              alt="Anti-tan solutions for healthy skin"
              loading="lazy"
            />
            <p className="font-bold text-xl mt-4">Tanning</p>
          </Link>

          <Link
            to="/product-category/oily skin"
            className="flex flex-col items-center justify-center mb-10"
            title="Best skincare products for oily skin"
          >
            <img
              src={oily}
              alt="Oily skin control products"
              loading="lazy"
            />
            <p className="font-bold text-xl mt-4">Oily Skin</p>
          </Link>

          <Link
            to="/product-category/dry skin"
            className="flex flex-col items-center justify-center mb-10"
            title="Moisturizing products for dry skin"
          >
            <img
              src={dry}
              alt="Dry skin hydration products"
              loading="lazy"
            />
            <p className="font-bold text-xl mt-4">Dry Skin</p>
          </Link>

          <Link
            to="/product-category/pimple"
            className="flex flex-col items-center justify-center mb-10"
            title="Pimple care and spot treatment"
          >
            <img
              src={pimple}
              alt="Pimple treatment skincare"
              className="rounded-full h-[196px] w-[196px]"
              loading="lazy"
            />
            <p className="font-bold text-xl mt-4">Pimple</p>
          </Link>

          <Link
            to="/product-category/spot"
            className="flex flex-col items-center justify-center mb-10"
            title="Spot removal and blemish care products"
          >
            <img
              src={spot}
              alt="Spot treatment solutions"
              className="rounded-full h-[196px] w-[196px]"
              loading="lazy"
            />
            <p className="font-bold text-xl mt-4">Spot</p>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default ShopByConcern;
